import {Component} from 'react'
import {Link} from 'react-router-dom'

import DoForm from '../../../../components/Forms/DoForm/DoForm.jsx'
import SubmitButton from '../../../../components/Forms/DoForm/SubmitButton.jsx'
import {generate} from '../../../../routes.js'
import UploadUserImageForm from '../../../../components/Forms/UploadUserImageForm/UploadUserImageForm.jsx'

export default class GeneralPresentation extends Component {
  onUploadSuccess = (image) => {
    this.props.updateUser({
      ...this.props.currentUser,
      image,
    })
  }

  onSubmit = (values) => {
    return this.props.submitUser({
      ...values,
    })
  }

  render() {
    return (
      <div>
        <div className=" step-general-presdo bg-white bd-gray-200 p-5">
          <h2 className="text-center">Présentation générale</h2>
          <p className="text-center mb-5">
            Merci de nous aider à vous connaitre
          </p>
          {this.props.currentUser &&
            <div>
              {this.props.currentUser.isBusinessManager &&
                <div className="row justify-content-center">
                  <div className="col-xl-9">
                    <UploadUserImageForm
                      image={this.props.currentUser.image}
                      userId={this.props.currentUser.id}
                      onUploadSuccess={this.onUploadSuccess}>
                    </UploadUserImageForm>
                  </div>
                </div>
              }
              <DoForm
                onSubmit={this.onSubmit}
                initialValues={this.props.currentUser}
                onSubmitSuccess={this.props.onFormSuccess} />
            </div>
          }
          {!this.props.edit &&
          <div className="mt-5 d-flex flex-wrap align-items-center">
            <div className="mr-auto">
              <Link to={generate({name: 'homepage'})} className="gray">
                Je finirai plus tard
              </Link>
            </div>
            <SubmitButton className="btn btn-primary ml-auto">Étape suivante</SubmitButton>
          </div>}
          {this.props.edit &&
          <div className="mt-5 d-flex">
            <SubmitButton className="btn btn-primary mx-auto">Sauvegarder</SubmitButton>
          </div>}
        </div>
      </div>
    )
  }
}
